module.exports = __webpack_public_path__ + "static/group-bg-4-46a97a6830fbb327659bf3eff62baf6f.jpg";